import React from 'react'
import imageSafariOne from '../../assets/safari1.png';
import imageSafariTwo from '../../assets/safari1.png';
import imageSafariThree from '../../assets/safari1.png';
import imageSafariFour from '../../assets/safari1.png';
import imageSafariFive from '../../assets/safari1.png';

import whiteCloudOne from "../../assets/white-clouds.png";
import cloudsOne from "../../assets/cloud-wt.png";
import { useEffect, useState } from 'react';
import * as CONSTANTS from "../../CONSTANTS";
import axios from "axios";

function HomeBanner() {
  const [videoData, setVideoData]                         = useState("");
  const [showVideo, setShowVideo]                         = useState(false);

  useEffect(() => {
      collectSettingsVideo();
  },[]);

  const collectSettingsVideo = async () => {
      try{
          const resSet = await axios.get(CONSTANTS.API_URL +"settings/structure/");

          setVideoData(resSet.data[0]?.youtubeLink);
          
      }catch(err){
          console.log(err);
      }
  }

  return (
    <div className="banner-begin" style={{ 
            backgroundImage: `url("${imageSafariOne}")` 
        }}>
                       
        <h1 className="hm-head">Fall in <span className="larg-prelific">love</span> with South Africa.</h1>
        {
          videoData &&
          videoData.length > 5 && (
            <button className="btn-unstyle btn-play btn-play-home" onClick={() => setShowVideo(true)}>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                    </path>
                </svg>
            </button>
          )
        }
        
        {
          showVideo && (
            <div className="video-modal">
              <button type="button" className="btn btn-default btn-gold repsisition" onClick={() => setShowVideo(false)}>Close</button>
              <video className="vidstag" controls>
                    <source src={videoData} type="video/mp4" />
                </video>
            </div>
          )
        }
        <div className="clouds">
          {
            /*
            <img src={whiteCloudOne} style="--i:1;" />
            <img src={cloudsOne} style="--i:2;" />
            <img src={whiteCloudOne} style="--i:3;" />
            <img src={cloudsOne} style="--i:4;" />
            */
          }
        </div>
    </div>
  )
}

export default HomeBanner